import moment from 'moment-timezone';
import { format } from 'timeago.js';


export function isValidTimezone(value) {
  if (moment.tz.zone(value)) {
    return true;
  } else {
    return false;
  }
}

export function getTimeagoDisplay(dt) {
  const nowTs = Math.floor(Date.now() / 1000);
  const ts = Math.floor(dt / 1000);
  const diff = nowTs - ts;
  if (nowTs > ts && 60 > diff) return 'Just Now';
  return format(dt);
}

// Given datetime value and timezone, prettify it similar to facebook datetime display
// 2 mins ago, 2 hrs ago, 7 Nov at 16:13, 7 Nov 2015 at 16:13
export function getDatetimeDisplay(dt, timezone=moment.tz.guess()) {
  const nowEpoch = moment().unix();
  const dtEpoch = moment(dt).unix();
  const yearStartEpoch = moment().startOf('year').unix();

  const diff = nowEpoch - dtEpoch;
  if (60 > diff) return 'Just Now';
  if (120 > diff && diff >= 60) return '1 min ago';
  if (3600 > diff && diff >= 120) return `${parseInt(diff/60)} mins ago`;
  if (7200 > diff && diff >= 3600) return '1 hr ago';
  if (86400 > diff && diff >= 7200) return `${parseInt(diff/3600)} hrs ago`;

  // If is this year
  if (dtEpoch > yearStartEpoch) return moment(dt).tz(timezone).format("D MMM [at] HH[:]mm");
  return moment(dt).tz(timezone).format("D MMM YYYY [at] HH[:]mm");
}

// 7 Nov 2017 at 16:13 (2 weeks ago)
export function getDetailedDatetimeDisplay(dt, timezone=moment.tz.guess()) {
  const timeAgoDisplay = getTimeagoDisplay(dt);
  const dtDisplay = moment(dt).tz(timezone).format("D MMM YYYY [at] HH[:]mm");
  return `${dtDisplay} (${timeAgoDisplay})`;
}

// 1 month ago (16th Nov 2020 at 16:13)
export function getTimeagoWithDatetimeDisplay(dt, timezone=moment.tz.guess()) {
  return `${getTimeagoDisplay(dt)} (${moment(dt).tz(timezone).format("Do MMM YYYY [at] HH[:]mm")})`;
}

// Mar 21 2021 17:13:48 GMT+0800
// Mar 21 2021 17:13:48 GMT
export function convertUTCWithoutOffset(date) {
  const offset = new Date().getTimezoneOffset();
  return moment(date).subtract(offset, 'minutes').utc();
}
